import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';

import HelpToolTip from 'components/HelpToolTip';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import { MENU_ITEM_NAMES } from 'styles/constants/appearanceSectionNames';
import { mapCartToServiceFeeType } from 'bento-ordering/utils/HonestPricingLaw';
import { getValueWithTwoDecimalPlace } from 'helpers/formattedDollar';

const flexProps = {
  justifyContent: 'space-between',
  display: 'flex'
};

const HonestPricingLawCartMessage = ({
  onlineOrderingServiceFee,
  cartSubtotal
}) => {
  const cart = useSelector(state => state.cart);
  const {
    is_group_order: isGroupOrder,
    online_ordering_fulfillment_method: onlineOrderingFulfillmentMethod,
    display_service_fee: displayServiceFee,
    online_ordering_custom_fee: onlineOrderingCustomFee,
    online_ordering_custom_fee_name: onlineOrderingCustomFeeName
  } = cart;

  const { feeType, cartItemizedHelperText } = mapCartToServiceFeeType(
    displayServiceFee,
    onlineOrderingFulfillmentMethod,
    isGroupOrder
  );
  const totalStyles = { variant: MENU_ITEM_NAMES, fontSize: '16px' };

  // Rounded values in two decimals
  const cartSubtotalFormatted = getValueWithTwoDecimalPlace(cartSubtotal);

  return (
    <>
      {!!parseFloat(onlineOrderingServiceFee) && (
        <Box marginBottom={2} {...flexProps}>
          <Box justifyContent="flex-start">
            <StyledTypographyColorSectionNavLinkMain
              {...totalStyles}
              fontWight={500}
            >
              {feeType}
            </StyledTypographyColorSectionNavLinkMain>
            <HelpToolTip>{cartItemizedHelperText}</HelpToolTip>
          </Box>
          <StyledTypographyColorSectionNavLinkMain
            {...totalStyles}
            data-testid="online-ordering-service-fee"
          >
            ${onlineOrderingServiceFee}
          </StyledTypographyColorSectionNavLinkMain>
        </Box>
      )}
      {!!onlineOrderingCustomFeeName && (
        <Box marginBottom={2} {...flexProps}>
          <Box justifyContent="flex-start">
            <StyledTypographyColorSectionNavLinkMain
              {...totalStyles}
              fontWight={500}
            >
              Other Fees:
            </StyledTypographyColorSectionNavLinkMain>
            <HelpToolTip>{`${onlineOrderingCustomFeeName}: ${onlineOrderingCustomFee}`}</HelpToolTip>
          </Box>
          <StyledTypographyColorSectionNavLinkMain
            {...totalStyles}
            data-testid="online-ordering-custom-fee"
          >
            ${onlineOrderingCustomFee}
          </StyledTypographyColorSectionNavLinkMain>
        </Box>
      )}
      <Box marginBottom={2} {...flexProps}>
        <Box justifyContent="flex-start">
          <StyledTypographyColorSectionNavLinkMain
            {...totalStyles}
            fontWight={500}
          >
            Cart Subtotal
          </StyledTypographyColorSectionNavLinkMain>
        </Box>
        <StyledTypographyColorSectionNavLinkMain
          {...totalStyles}
          data-testid="cart-subtotal"
        >
          ${cartSubtotalFormatted}
        </StyledTypographyColorSectionNavLinkMain>
      </Box>
    </>
  );
};

HonestPricingLawCartMessage.propTypes = {
  cartSubtotal: PropTypes.number.isRequired,
  onlineOrderingServiceFee: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default HonestPricingLawCartMessage;
